/** @jsxImportSource @emotion/react */

import { CSSObject } from '@emotion/react';

import { IBasePart } from '../part';

export interface ISpacePart extends IBasePart {
  type: 'space';
  height: number;
}

const SpacePart = (data: ISpacePart) => {
  const STYLE: CSSObject = {
    height: data.height,
  };

  return <div css={STYLE} />;
};

export default SpacePart;
